import RouterRoute from './RouterRoute';
export default RouterRoute;
